import { createStyles } from '../../../../../../../styles/helpers'

const useStyles = createStyles({
  datePickersList: {
    justifyContent: 'space-between',
    '& .field': {
      width: '100%'
    }
  }
})

export default useStyles
